// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2tDGU","content":"RecentSearches_content__3PqjX"};